const Footer = () => (
  <footer className="app-footer-container">
    &copy; RPM {new Date().getFullYear()} Updated :{" "}
    {new Date().toISOString().split(".")[0].replace("T", " ")}
  </footer>
);

export { Footer as default };
